import Flickity from 'flickity'
import isNull from 'lodash/isNull'

export default class Trustpilot {
    constructor() {
        this.cacheDom()
        this.init()
        this.bindEvents()
    }

    cacheDom() {
        this.flkty = null
        this.reviews = document.querySelector('.trustpilot-reviews-slider')
        this.nextButton = document.querySelector('.trustpilot-reviews-controls-next')
        this.prevButton = document.querySelector('.trustpilot-reviews-controls-prev')
    }

    bindEvents() {
        if (!isNull(this.flkty)) {
            this.nextButton.addEventListener('click', () => {
                console.log('button has been clicked')
                this.flkty.next(true, false)
            })

            this.prevButton.addEventListener('click', () => {
                this.flkty.previous(true, false)
            })
        }
    }

    init() {
        if (!isNull(this.reviews)) {
            this.flkty = new Flickity(this.reviews, {
                cellAlign: 'left',
                draggable: true,
                freeScroll: true,
                pageDots: false,
                prevNextButtons: false,
                wrapAround: true,
                autoPlay: 5000,
            })
        }
    }
}
